<template>
  <ButtonBase
    tag="button"
    :class="$style.button__secondary"
    :state="state"
    :type="type"
    :theme="secondary"
    :test-id="testId"
  >
    <slot />
  </ButtonBase>
</template>

<script setup lang="ts">
import type { ActionPropsType } from './config/ActionProps.type';
import { ActionState } from './config/ActionState';
import { ButtonType } from './config/ButtonType';

type Props = ActionPropsType & {
  state?: ActionState;
  type?: ButtonType;
};
withDefaults(defineProps<Props>(), {
  state: ActionState.Idle,
  type: ButtonType.Button,
  autofocus: false,
});

const secondary = {
  backgroundColor: 'var(--color-mono-100)',
  backgroundColorHover: 'var(--color-mono-700)',
  borderColor: 'var(--color-mono-700)',
  textColor: 'var(--color-mono-700)',
  textColorHover: 'var(--color-mono-100)',
  loadingColor: 'var(--color-mono-700)',
};
</script>
<style lang="postcss" module>
.button__secondary {
  box-shadow: none;
}
</style>
